import React, {FunctionComponent} from 'react';
import {Grid, IconButton, makeStyles} from '@material-ui/core';
import {LeftIcon, RightIcon} from '@treez-ui/core/icons';
import {Title, TitleSize} from '@treez-ui/core/layout/Title';
import {TreezColor, treezColorMap} from '~/styles/constants';

const {OFF_WHITE, GREY_MEDIUM} = TreezColor;

interface Props {
    numberOfProducts: number;
    numberOfProductsToShow: number;
    showNextProduct: () => void;
    showPreviousProduct: () => void;
    startingProductIndex: number;
}

export const MergeTableHeaderCell: FunctionComponent<Props> = (props: Props) => {
    const {
        numberOfProducts,
        numberOfProductsToShow,
        showNextProduct,
        showPreviousProduct,
        startingProductIndex,
    } = props;

    const useStyles = makeStyles({
        headerContainer: {
            height: '111px',
            maxHeight: '111px',
            backgroundColor: treezColorMap[OFF_WHITE],
            borderBottom: `1px solid ${treezColorMap[GREY_MEDIUM]}`,
            boxSizing: 'border-box',
            padding: '4px',
        },
        headerTitle: {
            padding: '0 4px',
        },
        mergeDetailsControls: {
            height: '40px',
            display: 'flex',
            alignItems: 'center',
        },
        paginationButton: {
            maxWidth: '30px',
            height: '30px',
        },
    });

    const {headerContainer, headerTitle, mergeDetailsControls, paginationButton} = useStyles();

    return (
        <Grid item container className={headerContainer} sm={12} alignContent="center">
            <Grid item sm={12} className={headerTitle}>
                <Title text="Product Details" size={TitleSize.SMALL} />
            </Grid>
            {numberOfProducts > numberOfProductsToShow && (
                <Grid item container className={mergeDetailsControls} sm={12}>
                    <Grid item container sm={1}>
                        <IconButton
                            className={paginationButton}
                            disabled={startingProductIndex === 0}
                            onClick={showPreviousProduct}
                        >
                            <LeftIcon />
                        </IconButton>
                    </Grid>
                    <Grid item container sm={10} justifyContent="center">
                        {`Showing ${startingProductIndex + 1} - ${
                            startingProductIndex + numberOfProductsToShow
                        } of ${numberOfProducts}`}
                    </Grid>
                    <Grid item container sm={1} onClick={showNextProduct}>
                        <IconButton className={paginationButton}>
                            <RightIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};

export default MergeTableHeaderCell;
